/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

export enum RailBackgroundImageName {
  RECORDING = 'myrecordings',
  WISHLIST = 'wishlist',
  PURCHASES = 'purchases',
  WATCH_NEXT = 'watchnext',
  RELATED = 'recomm',
  RELATED_RECOMM = 'recomm',
}
